module.exports = __webpack_public_path__ + "media/images/talent/feature-03-de5ca58fec9e9f20e14f4a652b2e5485.svg";